import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication/authentication.service';
import { LoggingService } from './logging/logging.service';
import { CreateSubscriptionFeature, SubscriptionFeature, UpdateSubscriptionFeature } from '../models/inModels/SubscriptionFeatures';

@Injectable()
export class SubscriptionFeaturesService {
	private routeCategory = '/api/subscriptions/features';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService
	) { }

	create(model: CreateSubscriptionFeature): Promise<CreateSubscriptionFeature> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/create`, JSON.stringify(model), { headers: this.auth.header })
			.toPromise()
			.then(response => response as SubscriptionFeature)
			.catch(error => this.logging.handleError(error));
	}

	getDropdownList(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/dropdown`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	update(user: UpdateSubscriptionFeature): Promise<SubscriptionFeature> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as SubscriptionFeature)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number, key: string): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/delete/${id}/${key}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/subscription-features.service.ts